document.querySelectorAll('.thumbnail-slider').forEach((slider) => {
  const sliderComponent = slider;
  const sliderList = slider.querySelector('.thumbnail-list');
  let isDown = false;
  let startX;
  let scrollLeft;

  const isDesktop = () => window.innerWidth >= 989;

  sliderList.addEventListener('mousedown', (e) => {
    if (!isDesktop()) return;
    isDown = true;
    startX = e.pageX - sliderList.offsetLeft;
    scrollLeft = sliderList.scrollLeft;
    sliderList.style.cursor = 'grabbing';
  });

  sliderList.addEventListener('mouseleave', () => {
    if (!isDesktop()) return;
    isDown = false;
    sliderList.style.cursor = 'grab';
  });

  sliderList.addEventListener('mouseup', () => {
    if (!isDesktop()) return;
    isDown = false;
    sliderList.style.cursor = 'grab';
  });

  sliderList.addEventListener('mousemove', (e) => {
    if (!isDown || !isDesktop()) return;
    e.preventDefault();
    const x = e.pageX - sliderList.offsetLeft;
    const walk = (x - startX) * 1;
    sliderList.scrollLeft = scrollLeft - walk;
  });

  sliderList.addEventListener(
    'touchstart',
    (e) => {
      if (isDesktop()) return;
      isDown = true;
      startX = e.touches[0].pageX - sliderList.offsetLeft;
      scrollLeft = sliderList.scrollLeft;
    },
    false,
  );

  sliderList.addEventListener(
    'touchend',
    () => {
      if (isDesktop()) return;
      isDown = false;
    },
    false,
  );

  sliderList.addEventListener(
    'touchmove',
    (e) => {
      if (!isDown || isDesktop()) return;
      const x = e.touches[0].pageX - sliderList.offsetLeft;
      const walk = (x - startX) * 1;
      sliderList.scrollLeft = scrollLeft - walk;
    },
    false,
  );

  if (isDesktop()) {
    sliderList.style.cursor = 'grab';
  }
});
